import { DEFAULT_CURRENCY_CODE, EnvironmentProviders, InjectionToken, LOCALE_ID, Provider } from '@angular/core';
import { MEDIA_BREAKPOINTS, provideMediaObserver } from '../services';

export const LOCAL_IMAGE_PROCESSING_ENABLED = new InjectionToken<boolean>('Local image processing enabled', {
  factory: () => false,
});

export const ENVIRONMENT_PROVIDERS: (EnvironmentProviders | Provider)[] = [
  { provide: LOCALE_ID, useValue: 'en' },
  {
    provide: DEFAULT_CURRENCY_CODE,
    useValue: 'USD',
  },
  provideMediaObserver(MEDIA_BREAKPOINTS),
];
